import { Divider } from '@material-ui/core';
import styled from 'styled-components';

const FormDivider = styled(Divider)<{ margin?: string }>`
  width: 100%;
  margin: ${({ margin }) => (margin ? `${margin}` : '18px 0 5px 0px')};
`;

export default FormDivider;
